module.exports = __webpack_public_path__ + "img/subir.eeebe087.svg";